export default __webpack_public_path__ + "media/src/assets/images/truck-f8cd4582666cb27f050a86ccef1e90c2.svg";